import {get, post, postJson, patchJson, deleteMethod, formatUrl} from '../../../utils/request'
import {
  LIST_CATEGORY,
  LIST_COUNTRY,
  LIST_CITY,
  LIST_NEIGHBORHOOD,
  CREATE_JOB,
  LIST_LEVEL_EXPERIENCE,
  JOB_DETAIL, JOB_INTEREST,
  JOB_REJECT_OFFER,
  EDIT_JOB_EMPLOYER,
  JOB_DETAIL_TALENT,
  CHAT_ROOM
} from '../../../utils/urls'

const actions = {
  fetchListCategory: async (context, payload) => {
    try {
      let response = await get(LIST_CATEGORY, payload)
      let status = response.status
      if (status === 200) {
        context.commit('setListCategory', response.data['results'])
      }
    } catch (e) {
      context.commit('setListCategory', [])
    }
  },
  fetchListCountry: async (context) => {
    try {
      let response = await get(LIST_COUNTRY)
      let status = response.status
      if (status === 200) {
        context.commit('setListCountry', response.data['results'])
      }
    } catch (e) {
      context.commit('setListCountry', [])
    }
  },
  fetchListCity: async (context, payload) => {
    try {
      let response = null
      if (payload && payload.query.country_id) {
        response = await get(LIST_CITY, payload.query)
      } else {
        response = await get(LIST_CITY)
      }
      let status = response.status
      if (status === 200) {
        context.commit('setListCity', response.data['results'])
      }
    } catch (e) {
      context.commit('setListCity', [])
    }
  },
  fetchListLevelExprerience: async (context) => {
    try {
      let response = await get(LIST_LEVEL_EXPERIENCE)
      let status = response.status
      if (status === 200) {
        context.commit('setListLevelExprerience', response.data['results'])
      }
    } catch (e) {
      context.commit('setListLevelExprerience', [])
    }
  },
  getListNeighborhood: async (context, payload) => {
    try {
      let url = formatUrl(LIST_NEIGHBORHOOD, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setListNeighborhood', response.data['results'])
      }
    } catch (e) {
      context.commit('setListNeighborhood', [])
    }
  },
  postCreateJob: async (context, payload) => {
    return postJson(CREATE_JOB, payload.params)
  },
  editJob: async (context, payload) => {
    let url = formatUrl(EDIT_JOB_EMPLOYER, payload.params)
    return patchJson(url, payload.body)
  },
  getDetailJob: async (context, payload) => {
    try {
      let url = formatUrl(JOB_DETAIL, payload.params)
      if (payload.params && payload.params.talent_id) {
        url = formatUrl(JOB_DETAIL_TALENT, payload.params)
      }
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setDetailJob', response.data)
      }
    } catch (e) {
      // Reset to a safe empty shape with nested objects rather than [].
      // Consumers (e.g. job-post.vue) read fields like jobDetail.user.user_id;
      // with [] that throws a TypeError and blanks the page, with this shape
      // it reads as `undefined` and the template renders safely. Re-throw so
      // the calling component can hide its loader and surface an error.
      context.commit('setDetailJob', {
        user: {},
        level_experience: {},
        neighborhood: {},
        city_town: {}
      })
      throw e
    }
  },
  postInterestJob: async (context, payload) => {
    let response = await post(JOB_INTEREST, payload.params)
    let status = response.status
    if (status === 201) {
      context.commit('setJobDetailNew', response.data)
    }
  },
  createChatRoom: async (context, payload) => {
    return post(CHAT_ROOM, {
      talent_interest_job: payload.talent_interest_job,
      user_post_job: payload.user_post_job
    })
  },
  jobRejectOffer: async (context, payload) => {
    let url = formatUrl(JOB_REJECT_OFFER, payload.params)
    await deleteMethod(url)
  }
}

export default actions
